module.exports = __webpack_public_path__ + "static/header-hero-82edc3ff35884c1794d35881b28c0b76.png";